import React, { FC } from "react";
import TailSpinLoader from "../TailSpinLoader";

export type ButtonProps = {
    isLoading?: boolean;
    isHoa?: boolean;
    btnText: string;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void; // Optional onClick handler
    type: 'submit' | 'confirm' | 'cancel' | 'close' | 'button' | any; // Type for different button functionalities
    className?: any;
    title?: string;
    isVisible?: boolean;
    isDisabled?: boolean;
};

const Button: FC<ButtonProps> = ({
    className = "",
    isLoading = false,
    isHoa = false,
    btnText,
    onClick,
    type,
    title = "",
    isVisible = true,
    isDisabled = false,
}) => {

    // Define button styles based on the type
    const getButtonClasses = () => {
       
        const commonClasses = isDisabled ? "bg-text-3" : "font-normal";
        switch (type) {
            case "close":
                return `${commonClasses} bg-surface-5 text-surface-0 rounded-lg`;
            case "submit":
            case "confirm":
            case "button":
                return `${commonClasses}  ${isHoa ? 'bg-highlight-1' : 'bg-highlight-0'} text-text-0 rounded-lg`;
            case "cancel":
                return `${commonClasses} bg-text-9 text-surface-0 rounded-lg`;
            default:
                return className ? `${className} ${commonClasses} text-text-0 rounded-lg` : `${commonClasses} bg-[#28A745] text-text-0 rounded-lg`;

        }
    };

    // Prevent onClick if button is disabled
    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (!isDisabled && onClick) {
            onClick(e);
        }
    };

    // Conditionally render the button based on permission
    return (

        <>
            {isVisible &&
                <button
                    type={type === "submit" ? "submit" : "button"} // Handle submit button type
                    onClick={handleClick}
                    title={title}
                    className={`inline-flex px-2 py-1 items-center rounded ${getButtonClasses()}  ${className} ${isDisabled ? "cursor-not-allowed" : ""}`}
                    disabled={isLoading || isDisabled} // Disable button while loading or if disabled
                >
                    {isLoading ? (
                        <>
                            Loading...
                            <TailSpinLoader />
                        </>
                    ) : (
                        btnText
                    )}
                </button>
            }
        </>

    );
};

export default Button;

